import { Document, Page, View, Text } from '@react-pdf/renderer';
import { LABEL_SIZE, labelStyles, dash } from './labelStyles';
import { QrImage } from './labelPrimitives';

export const FinishedGoodLabelDocument: React.FC<{ packingCode?: string; qrDataUrl: string }> = ({
  packingCode,
  qrDataUrl,
}) => (
  <Document>
    <Page size={LABEL_SIZE} style={labelStyles.page}>
      <QrImage src={qrDataUrl} />
      <View style={labelStyles.info}>
        <Text style={labelStyles.title}>{dash(packingCode)}</Text>
      </View>
    </Page>
  </Document>
);
